import React from "react";
import { Button } from "reactstrap";

class ButtonWithLoader extends React.Component {
  constructor() {
    super();
  }

  render() {
    const {
      className,
      color,
      text,
      isLoading,
      loadingText,
      isDirty,
      dirtyText,
      ...attrs
    } = this.props;

    let cs = className, disabled = false, buttonText = text;
    if (isLoading) {
      cs += " loading";
    }

    if (isDirty) {
      buttonText = dirtyText;
    }

    if (isLoading) {
      buttonText = loadingText;
    }

    if (isDirty !== undefined && (!isDirty || isLoading)) {
      disabled = true;
    }

    return (
      <Button className={cs} color={color} disabled={disabled} {...attrs}>
        {isLoading &&
          <i className="loader fa fa-fw fa-circle-o-notch fa-spin" />}
        {buttonText}
      </Button>
    );
  }
}

export default ButtonWithLoader;



/** WEBPACK FOOTER **
 ** ./src/browser/components/Form/ButtonWithLoader.js
 **/